<template>
  <div>
<!--    {{ item }}-->

    <CRow  class="mb-2">
      <CCol class="text-center">
        <div style="width: 100px; height: 100px; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-align: center;" class="font-weight-bold text-white bg-gradient-success">
        <label class="font-sm">
          IDP  <br>
          Progress
        </label>
        </div>
      </CCol>
      <CCol col="10">
        <div class="overflow-auto">
          <ul class="timeline" id="timeline" style="width: max-content" >
            <li class="li" :class="(objs.complete === true)?'complete':''" v-for="objs in item">
              <div class="timestamp">
                <span class="author" v-if="!(objs.author === '')">{{ objs.author }}</span>
                <span class="date" v-if="!(objs.date === '')">{{ objs.date }}</span>
              </div>
              <div class="status" v-if="!(objs.state === '')"  >
                <samp> {{objs.state}} </samp>
              </div>
            </li>
          </ul>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import moment from "moment";

export default {
  name: 'Timeline',
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Individual Development Plan'
    },
    objs: {
      type: Object,
      default() {
        return null
      }
    },

    disabled: {
      type: Boolean,
      default: false
    },
  },

  data: function () {
    return {
      item: [
        {author: "เริ่มกระบวนการ", date: "จัดทำแผน IDP", state: " ", complete: false},
        {author: "พนักงานจัดทำ", date: "แผน IDP", state: " ", complete: false},
        {author: "ผู้บังคับบัญชา", date: "พิจารณาแผน", state: " ", complete: false},
        {author: "ดำเนินการพัฒนา", date: "ตามแผน IDP", state: " ", complete: false},
        {author: "สิ้นสุดกระบวนการพัฒนา", date: "ผลการพัฒนา", state: " ", complete: false}
      ]
    }
  },

  mounted() {

  },

  created() {
    this.isStateView();
  },

  beforeDestroy() {
  },


  methods: {
    isOpenDoc() {
    },

    isStateView() {

      switch (this.objs.historys[0].status.at(-1).state._id) {
        case "682fda91568cbed3cad2c0a4":
          this.item[0].complete = true;
          this.item[1].complete = false;
          this.item[2].complete = false;
          this.item[3].complete = false;
          this.item[4].complete = false;
          break;

        case "654851a37ab25be71bbeeed6": // Pending
          this.item[0].complete = true;
          this.item[1].complete = false;
          this.item[2].complete = false;
          this.item[3].complete = false;
          this.item[4].complete = false;
          break;
        case "654851dbe41b7f46025977f6": // Save
          this.item[0].complete = true;
          this.item[1].complete = true;
          this.item[2].complete = false;
          this.item[3].complete = false;
          this.item[4].complete = false;
          break;
        case "654851ece41b7f46025977fa": // Send
          this.item[0].complete = true;
          this.item[1].complete = true;
          this.item[2].complete = false;
          this.item[3].complete = false;
          this.item[4].complete = false;
          break;

        case "6723709ab9a2030e40d1b884": // Reject
          this.item[0].complete = true;
          this.item[1].complete = true;
          this.item[2].complete = false;
          this.item[3].complete = false;
          this.item[4].complete = false;
          break;

        case "67bc20d5ef3c015b73cf6dbc": // Verification
          this.item[0].complete = true;
          this.item[1].complete = true;
          this.item[2].complete = true;
          this.item[3].complete = false;
          this.item[4].complete = false;
          break;

        case "67bc35d9ac0179614e274a67": // development
          this.item[0].complete = true;
          this.item[1].complete = true;
          this.item[2].complete = true;
          this.item[3].complete = true;
          this.item[4].complete = false;
          break;

        case "67bfc7e724e13ba338b58e47": // result in development
          this.item[0].complete = true;
          this.item[1].complete = true;
          this.item[2].complete = true;
          this.item[3].complete = true;
          this.item[4].complete = false;
          break;

        case "67bfc7ed24e13ba338b58e4d": // complete
          this.item[0].complete = true;
          this.item[1].complete = true;
          this.item[2].complete = true;
          this.item[3].complete = true;
          this.item[4].complete = true;
          break;

      }
    }

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {
    lang(value) {
      var lang = this.$store.getters['setting/lang']
    },

    objs(value) {
    }

  }
}
</script>
<style>
.text-right > input[type="number"] {
  text-align: right;
}

.c-switch-input + .c-switch-slider {
  background-color: inherit;
  border-color: #fc1515;
}

.c-switch-input + .c-switch-slider::after {
  color: #fc1515;
}

.c-switch-input + .c-switch-slider::before {
  background-color: #fc1515;
  border-color: #fc1515;
}
</style>
